module.exports = __webpack_public_path__ + "img/delicious.c0d07300.svg";